import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

const Projects: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      textAlign: 'center',
      color: '#FFFFFF'
    }}>
      <Title level={2} style={{ color: '#FFFFFF', marginBottom: '16px' }}>
        Projects
      </Title>
      <Text style={{ color: '#B8B8B8' }}>
        Project list view coming soon
      </Text>
    </div>
  );
};

export default Projects;
